export interface TaskFailureTarget {
  id: string;
  taskNumber: number;
  shipment?: { shipmentNumber?: number | null } | null;
  shipmentSnapshot?: unknown;
  type: string;
  status: string;
  cancellationReviewPending?: boolean;
  workHold?: { reason: string; requestedAt?: string | null } | null;
}

interface FailureReason {
  label: string;
  code: number;
}

const DELIVERY_FAILURE_REASONS: FailureReason[] = [
  { label: "Recipient refused package", code: 7 },
  { label: "Package damaged", code: 8 },
  { label: "Incorrect Delivery Address", code: 3 },
  { label: "Unable to reach recipient", code: 6 },
  { label: "Other reason - Informed customer service", code: 9 },
  { label: "Final failure - No retry", code: 14 },
];

const PICKUP_FAILURE_REASONS: FailureReason[] = [
  { label: "Shipment canceled", code: 1 },
  { label: "Incorrect Pickup Address", code: 2 },
  { label: "Pickup not ready", code: 4 },
  { label: "Unable to reach sender", code: 5 },
  { label: "Other reason - Informed customer service", code: 9 },
  { label: "Final failure - No retry", code: 14 },
];

const RETURN_FAILURE_REASONS: FailureReason[] = [
  { label: "Shipment canceled", code: 1 },
  { label: "Incorrect Return Address", code: 10 },
  { label: "Return not ready", code: 11 },
  { label: "Unable to reach sender", code: 5 },
  { label: "Other reason - Informed customer service", code: 9 },
  { label: "Final failure - No retry", code: 14 },
];

const CARRIER_DROPOFF_FAILURE_REASONS: FailureReason[] = [
  { label: "Carrier location closed", code: 12 },
  { label: "Package damaged", code: 8 },
  { label: "Incorrect dropoff address", code: 13 },
  { label: "Other reason - Informed customer service", code: 9 },
  { label: "Final failure - No retry", code: 14 },
];

export function failureReasonsForTask(type: string): FailureReason[] {
  switch (type) {
    case "CUSTOMER_PICKUP":
      return PICKUP_FAILURE_REASONS;
    case "CUSTOMER_DELIVERY":
      return DELIVERY_FAILURE_REASONS;
    case "CUSTOMER_RETURN":
      return RETURN_FAILURE_REASONS;
    case "CARRIER_DROPOFF":
      return CARRIER_DROPOFF_FAILURE_REASONS;
    default:
      return [];
  }
}

export function canFailTask(status: string, type: string): boolean {
  return (
    (status === "PENDING" || status === "IN_PROGRESS") &&
    failureReasonsForTask(type).length > 0
  );
}
